import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/vhe/auxiliaries/order-maintenance-subtypes/list/all`)
    },
}